(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cc-hat-pair"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('cc-hat-pair'))customElements.define('cc-hat-pair',class extends HTMLElement{
 connectedCallback(){
  this.addEventListener('change',event=>{
   if(event.target.tagName!=='SELECT')return;
   const option=event.target.selectedOptions[0],card=event.target.closest('article'),image=card.querySelector('img');
   image.removeAttribute('srcset');image.src=option.dataset.image;image.alt=option.dataset.alt;
   card.querySelector('.cc-pair__price').textContent=option.dataset.formattedPrice;
   const total=Array.from(this.querySelectorAll('select')).reduce((sum,select)=>sum+Number(select.selectedOptions[0].dataset.price),0);
   this.querySelector('[data-total]').textContent=new Intl.NumberFormat(document.documentElement.lang,{style:'currency',currency:JSON.parse(this.querySelector('[data-currency]').textContent)}).format(total/100);
  });
  this.querySelector('button')?.addEventListener('click',async event=>{
   const button=event.currentTarget;if(button.disabled)return;button.disabled=true;button.textContent=this.dataset.adding;
   const status=this.querySelector('[data-status]');status.textContent='';
   try{
    const items=Array.from(this.querySelectorAll('select')).map(select=>({id:Number(select.value),quantity:1}));
    const response=await fetch(window.Shopify.routes.root+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items})});
    if(!response.ok)throw new Error('Cart update failed');
    location.assign(this.dataset.cart);
   }catch(error){status.textContent=this.dataset.error;button.disabled=false;button.textContent=this.dataset.add;}
  });
 }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cc-volume-inquiry"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('cc-volume-inquiry')) customElements.define('cc-volume-inquiry',class extends HTMLElement{
 connectedCallback(){
  const context = new URLSearchParams(location.search).get('project');
  const allowed = ['corporate','teams','fundraising','events','repeat','campaign'];
  const contextText = allowed.includes(context) ? this.querySelector('[data-context-'+context+']')?.content.textContent.trim() : '';
  if(contextText){const note=this.querySelector('.cc-volume__context');note.textContent=contextText;note.hidden=false;}
  let attempts=0;
  const apply=()=>{
   const root=this.querySelector('shopify-forms-embed')?.shadowRoot;
   const form=root?.querySelector('form');
   if(!form)return false;
   if(!root.querySelector('[data-cc-volume-style]')){
    const style=document.createElement('style');style.dataset.ccVolumeStyle='';
    style.textContent=`
[data-current-step="form"] [class*="_formHeader_"]{display:none!important}
[data-sizing="form-wrapper"]{width:100%!important;max-width:none!important;display:block!important;padding:0!important}
[class*="_gridItemContent_"]{padding:0!important}
form{display:grid!important;grid-template-columns:1fr 1fr!important;gap:16px!important;max-width:none!important}
form>div,form>button{grid-column:1/-1}
form>div:has(>input#first_name),form>div:has(>input#last_name){grid-column:auto}
input,textarea,button{font-size:16px!important}
input,button[type="submit"]{min-height:48px}
button[type="submit"]{border-radius:4px!important;text-transform:none!important}
.cc-budget-help{font-size:14px;line-height:1.5;margin:8px 0 0;color:inherit}
@media(max-width:480px){form{grid-template-columns:1fr!important}}
`;root.append(style);
    const last=root.getElementById('last_name')?.parentElement;
    const email=root.getElementById('email')?.parentElement;
    if(last?.parentElement===form && email?.parentElement===form)form.insertBefore(last,email);
   }
   const textarea=root.querySelector('textarea[name="custom#project_details"]');
   const budgetButton=form.querySelector('button[aria-labelledby~="custom#estimated_budget-selector-label"]');
   const budgetHelp=this.querySelector('[data-budget-help]');
   if(budgetButton&&budgetHelp&&!root.getElementById('cc-budget-help')){
    const help=budgetHelp.cloneNode(true);help.id='cc-budget-help';help.className='cc-budget-help';help.removeAttribute('data-budget-help');
    budgetButton.parentElement.append(help);
    budgetButton.setAttribute('aria-describedby',[budgetButton.getAttribute('aria-describedby'),'cc-budget-help'].filter(Boolean).join(' '));
    budgetHelp.hidden=true;
   }
   const label=root.getElementById('label-custom#project_details');
   if(textarea&&label){textarea.id='cc-project-details';label.htmlFor=textarea.id;textarea.setAttribute('aria-labelledby',label.id);}
   const flow=['repeat','campaign'].includes(context)?this.querySelector('template[data-flow="'+context+'"]'):null;
   if(flow&&textarea&&!this.dataset.flowReady){
    this.dataset.flowReady='true';
    this.querySelector('h1').textContent=flow.dataset.title;
    this.querySelector('.cc-volume__heading > p:last-child').textContent=flow.dataset.description;
    const fields=this.querySelector('.cc-inquiry-fields');fields.append(flow.content.cloneNode(true));
    const marker='\n\n[Project notes]\n';
    const sync=()=>{
     const previous=textarea.value;
     const notes=previous.includes(marker)?previous.split(marker).slice(1).join(marker):previous.replace(contextText,'').trim();
     const answers=Array.from(fields.querySelectorAll('input')).filter(input=>input.value.trim()).map(input=>input.dataset.flowLabel+': '+input.value.trim());
     const value=[contextText,...answers].join('\n')+marker+notes;
     Object.getOwnPropertyDescriptor(HTMLTextAreaElement.prototype,'value')?.set?.call(textarea,value);
     textarea.dispatchEvent(new Event('input',{bubbles:true}));
    };
    fields.addEventListener('input',sync);sync();
   }
   if(textarea&&contextText&&!textarea.dataset.ccContext){
    textarea.dataset.ccContext='true';
    if(!textarea.value){
     const setter=Object.getOwnPropertyDescriptor(HTMLTextAreaElement.prototype,'value')?.set;
     setter?.call(textarea,contextText+'\n\n');textarea.dispatchEvent(new Event('input',{bubbles:true}));
    }
   }
   return true;
  };
  if(!apply())this.timer=setInterval(()=>{if(apply()||++attempts>80)clearInterval(this.timer)},250);
 }
 disconnectedCallback(){clearInterval(this.timer);}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
